import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
export function Navbar() {
  const navigate = useNavigate();
  const {
    pathname
  } = useLocation();
  const isLanding = pathname === '/';
  return <nav className={`fixed top-0 left-0 w-full z-50 px-6 py-6 transition-colors duration-300 ${isLanding ? 'mix-blend-difference text-white' : 'bg-white/80 backdrop-blur-md border-b border-neutral-100 text-neutral-900'}`} data-id="element-77">

      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-78">
        <button onClick={() => navigate('/')} className="font-bold text-xl tracking-tight hover:opacity-70 transition-opacity focus:outline-none" data-id="element-79">

          Stasis Group.
        </button>

        <div className="flex items-center gap-8" data-id="element-80">
          <div className="flex gap-6 text-sm font-medium" data-id="element-81">
            <button onClick={() => navigate('/projects')} className={`transition-colors ${isLanding ? 'hover:text-neutral-300' : 'hover:text-neutral-600'} ${pathname === '/projects' ? 'opacity-50 cursor-default' : ''}`} data-id="element-82">

              Projects
            </button>

            <a href="https://cal.com/stasis-group-africa/15min" target="_blank" className={`transition-colors ${isLanding ? 'hover:text-neutral-300' : 'hover:text-neutral-600'}`} data-id="element-83">

              Contact us
            </a>
          </div>
        </div>
      </div>
    </nav>;
}